import { connect } from 'react-redux';
import CitationData from './CitationData';

import { getCitationLoading } from '../../../../store/selectors/citation.selectors';
import { updateCitationBegin } from '../../../../store/actions/citation.actions';

const mapStateToProps = (state: any) => {
    const isLoading = getCitationLoading(state);
    return { isLoading };
};

const mapDispatchToProps = {
    updateCitation: updateCitationBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(CitationData);
